import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import {
  ListData,
  MerchantPackageList,
  StaffData,
  PackagesSpecData,
  PackagesSpecByIDData,
  PackageLogData,
  PackageData,
  ConfigData,
  PaymentConfig,
} from './types'

export const selectEvent = (state: RootState): Event => state.posReducer.Event

export const selectMerchantInit = (state: RootState): string => state.posReducer.merchantInit

export const selectActionEvent = (state: RootState): Event => state.posReducer.actionEvent

export const selectStaffList = (state: RootState): ListData => state.posReducer.staffList

export const selectRoles = (state: RootState): PackageData[] => state.posReducer.roles

export const selectDetailEvent = (state: RootState): Event => state.posReducer.detailEvent

export const selectDetail = (state: RootState): StaffData | undefined => state.posReducer.detail

export const selectMerchantPackageList = (state: RootState): { data: MerchantPackageList[]; event: Event } =>
  state.posReducer.merchantPackageList

export const selectPackagesSpec = (state: RootState): { data: PackagesSpecData[]; event: Event } =>
  state.posReducer.packageSpec

export const selectPackagesSpecByID = (state: RootState): { data?: PackagesSpecByIDData; event: Event } =>
  state.posReducer.packageSpecByID

export const selectPackageLogs = (state: RootState): { data: PackageLogData[]; event: Event } =>
  state.posReducer.packageLogs

export const selectIsPackageC = (state: RootState): boolean => state.posReducer.isPackageC

export const selectIsPackageEnterprise = (state: RootState): boolean => state.posReducer.isPackageEnterprise

export const selectIsHasPackageC = (state: RootState): boolean => state.posReducer.isHasPackage

export const selectConfigActionEvent = (state: RootState): Event => state.posReducer.config.actionEvent

export const selectConfigEvent = (state: RootState): Event => state.posReducer.config.event

export const selectConfig = (state: RootState): ConfigData | undefined => state.posReducer.config.data

export const selectConfigList = (state: RootState): ConfigData[] => state.posReducer.configList.data || []

export const selectPaymentConfigList = (state: RootState): PaymentConfig[] =>
  state.posReducer.paymentConfigList.data || []

export const selectPaymentConfigEvent = (state: RootState): Event => state.posReducer.paymentConfigList.event
